import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import SpinLoader from './shared/field_inputs/shared/SpinLoader';

import { HandlePatchPerson } from './requests/PersonRequests';
import { DeepCopy } from '../tables/shared/TableEventHelpers';
import EditText from './shared/field_inputs/text/EditText';
import EditSelect from './shared/field_inputs/select/EditSelect';
import ActionButtons from './shared/field_inputs/shared/ActionButtons';
import CloseButton from 'react-bootstrap/CloseButton';

import { DataContext } from '../../stores/crm-store';

const EditListModal = ({ persons, setPersons }) => {
    const {
        store: { RoleOptions },
        dispatch,
    } = useContext(DataContext);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const innerPersons = DeepCopy(persons);
    const [defaultFormValues, setDefaultFormValues] = useState(innerPersons);
    const [formValues, setFormValues] = useState(innerPersons);

    const [hasElementsChanged, setHasElementsChanged] = useState([]);
    let roleOptions = []
    if (RoleOptions != null) {
        roleOptions = RoleOptions.slice();
        roleOptions.unshift({
            name: "Ingen roll",
            id: ""
        });
    }

    useEffect(() => {
        if (hasElementsChanged.length === 0) {
            var hasChangedParams = Array.from({ length: persons.length }, () => false);
            setHasElementsChanged(hasChangedParams);
        }

        setDefaultFormValues(persons);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [persons]);

    const formComponents = [
        {
            propName: 'name',
            label: 'Namn',
            validate: (v) => (!v || !v.length ? 'Uppdatera Namn.' : ''),
            component: <EditText />,
        },
        {
            propName: 'role',
            label: 'Roll',
            validate: (v) => (!v || !v.length ? 'Uppdatera Roll.' : ''),
            component: <EditSelect options={roleOptions} />,
        },
        {
            propName: 'email',
            label: 'Email',
            validate: (v) => (!v || !v.length ? 'Uppdatera Email.' : ''),
            component: <EditText />,
        },
        {
            propName: 'phone',
            label: 'Telefonnummer',
            validate: (v) => (!v || !v.length ? 'Uppdatera Telefonnummer.' : ''),
            component: <EditText />,
        },
    ];

    const onCancel = () => {
        setFormValues(defaultFormValues);
        setHasElementsChanged([]);
        setIsModalOpen(false);
    };

    async function onSave() {
        setIsSaving(true);
        for (let i = 0; i < hasElementsChanged.length; i++) {
            if (hasElementsChanged[i]) {
                var response = await HandlePatchPerson(defaultFormValues[i], formValues[i]);
                if (response.success) {
                    var newPersons = DeepCopy(persons);
                    newPersons[i] = response.person;
                    setPersons(newPersons);
                    dispatch({ type: 'SHOW_SAVED_TOAST' });
                } else {
                    dispatch({ type: 'SHOW_ERROR_TOAST' });
                }
            }
        }

        setHasElementsChanged([]);
        setIsSaving(false);
        setIsModalOpen(false);
    }

    const onChange = (index, values) => {
        var newPersons = DeepCopy(formValues);
        newPersons[index] = values;

        setFormValues(newPersons);
    };

    const updateHasChanged = (index, value) => {
        var newHasChanged = DeepCopy(hasElementsChanged);
        newHasChanged[index] = value;

        setHasElementsChanged(newHasChanged);
    };

    return (
        <>
            <button
                type='button'
                className='btn btn-success crm-modal-btn justify-content-center align-content-center'
                onClick={() => setIsModalOpen(true)}>
                <div>Se fler personer...</div>
            </button>

            <Modal show={isModalOpen} onHide={onCancel} className='crm-list-items-modal d-flex align-items-center justify-content-center'>
                <div className='d-flex justify-content-between align-items-center px-3 py-2 border'>
                    <div className='d-flex flex-row'>
                        <h4 className='my-0 ml-0 mr-1'>Alla Personer på</h4>
                        <h4 className='margin-none c-green'>{persons[0].organization.name}</h4>
                    </div>
                    <CloseButton onClick={onCancel} className="px-1 pb-1 mb-1" />
                </div>
                <div className='add-item-form'>
                    <Modal.Body>
                        {formValues.map((item, index) => {
                            return (
                                <ListRow
                                    key={`list-item-${item.id}`}
                                    index={index}
                                    values={item}
                                    persons={persons}
                                    setPersons={setPersons}
                                    hasChanged={hasElementsChanged[index]}
                                    updateHasChanged={(value) => updateHasChanged(index, value)}
                                    formComponents={formComponents}
                                    onChange={onChange}
                                />
                            );
                        })}
                    </Modal.Body>
                    <Modal.Footer>
                        <ActionButtons {...{ onCancel, onSave, isSaving }} />
                    </Modal.Footer>
                </div>
            </Modal>
        </>
    );
};

export default EditListModal;

const ListRow = ({ index, values, persons, setPersons, formComponents, hasChanged, updateHasChanged, onChange }) => {
    const { dispatch } = useContext(DataContext);

    const [defaultFormValues, setDefaultFormValues] = useState(values);
    const [formValues, setFormValues] = useState(DeepCopy(values));
    const [errorMessages] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    async function onSave() {
        setIsSaving(true);
        if (formValues.role != null) {
            defaultFormValues.roleId = (defaultFormValues.role || {}).id;
            formValues.roleId = formValues.role.id;
        }
        var response = await HandlePatchPerson(defaultFormValues, formValues);

        if (response.success) {
            var newValues = DeepCopy(persons);
            newValues[index] = response.person;
            setPersons(newValues);
            dispatch({ type: 'SHOW_SAVED_TOAST' });
        } else {
            dispatch({ type: 'SHOW_ERROR_TOAST' });
        }

        setDefaultFormValues(formValues);
        setIsSaving(false);
        updateHasChanged(false);
    }

    const setAllValues = (x, y) => {
        var newValues = DeepCopy(formValues);
        newValues[x] = y;
        setFormValues(newValues);
        updateHasChanged(checkPersonChanged(defaultFormValues, newValues));

        onChange(index, newValues);
    };

    return (
        <div className='card d-flex flex-row w-100 p-1'>
            {formComponents && formComponents.map((c) => renderModalFormComponent(c, formValues, setAllValues, errorMessages))}
            {hasChanged ? (
                <button
                    className='btn btn-sm btn-success save-button mx-auto mt-auto mb-1 d-flex justify-content-center align-items-center'
                    style={{ height: 33, width: 70 }}
                    onClick={onSave}>
                    {isSaving ? <SpinLoader isLoading={isSaving} /> : <div>Spara</div>}
                </button>
            ) : null}
        </div>
    );
};

const renderModalFormComponent = (component, formValues, setFormValue, errorMessages) => {
    const errorMessage = errorMessages[component.propName];
    const isInvalid = errorMessage && errorMessage.length;
    return (
        <div key={component.propName} className='m-1 person-item-container'>
            {component.label ? <label>{component.label}</label> : <div style={{ paddingTop: '.3rem' }} />}
            {React.cloneElement(component.component, {
                isInvalid,
                value: formValues[component.propName],
                setValue: (v) => setFormValue(component.propName, v),
            })}
            {isInvalid && <div className='invalid-msg'>{errorMessage}</div>}
        </div>
    );
};

const checkPersonChanged = (person, newPerson) => {
    let isBasicFieldsEqual = (
        person.name === newPerson.name &&
        person.email === newPerson.email &&
        person.phone === newPerson.phone
    );
    if (!isBasicFieldsEqual) {
        return true;
    }
    if (person.role === null && newPerson.role === null) {
        return false;
    }
    if (person.role === null && newPerson.role !== null) {
        return true;
    }
    if (person.role !== null && newPerson.role === null) {
        return true;
    }
    if (person.role.name === newPerson.role.name) {
        return false;
    }
    return true;
};
